'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'
import { HelpCenterFaqEntryUrl } from '@marketplace-web/help-center/help-center-faq-entry-url-feature'
import {
  AccessChannel,
  FaqEntryType,
} from '@marketplace-web/help-center/help-center-faq-entry-url-data'

import { SAFETY_ASSETS_PREFIX } from '../constants'

const HowItWorksBuyerProtection = () => {
  const translate = useTranslate('how_it_works')
  const asset = useAsset(SAFETY_ASSETS_PREFIX)

  const renderInfoItem = ({
    imgSrc,
    title,
    description,
    faqEntry,
  }: {
    imgSrc: string
    title: string
    description: string
    faqEntry: FaqEntryType
  }) => (
    <div className="row">
      <div className="grid2 u-ui-padding-bottom-large@portables">
        <Image src={imgSrc} />
      </div>
      <div className="grid10 u-padding-right-large">
        <Text as="h2" text={title} type={Text.Type.Title} />
        <Spacer />
        <Text as="span" text={description} theme="muted" />
        <Spacer size={Spacer.Size.Large} />
        <HelpCenterFaqEntryUrl
          type={faqEntry}
          accessChannel={AccessChannel.ProductLink}
          render={url => (
            <a href={url} className="how-it-works__link" target="_blank" rel="noreferrer">
              {translate('learn_more')}
            </a>
          )}
        />
      </div>
    </div>
  )

  return (
    <div className="content-block">
      <div className="tear tear--bottom u-background-greyscale-level-6 u-zindex-bump">
        <div className="container">
          <div className="content-block__content u-ui-padding-bottom-x5-large u-ui-padding-horizontal-small">
            <div className="u-clearfix u-ui-margin-horizontal-small">
              <div className="content-block__heading u-ui-padding-vertical-x2-large@desktops u-ui-padding-top-x2-large@portables u-ui-padding-bottom-x2-large@portables">
                <Text as="h1" text={translate('safe_and_easy.title')} type={Text.Type.Heading} />
              </div>
              <div className="content-block__blocks">
                <div className="row">
                  <div className="grid6 u-ui-margin-bottom-x2-large@portables">
                    {renderInfoItem({
                      imgSrc: asset('safe.svg'),
                      title: translate('safe_and_easy.order_protection.title'),
                      description: translate('safe_and_easy.order_protection.description'),
                      faqEntry: FaqEntryType.BuyerProtection,
                    })}
                  </div>
                  <div className="grid6">
                    {renderInfoItem({
                      imgSrc: asset('guarantee.svg'),
                      title: translate('safe_and_easy.money_back_guarantee.title'),
                      description: translate('safe_and_easy.money_back_guarantee.description'),
                      faqEntry: FaqEntryType.IhaiRefundPolicy,
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowItWorksBuyerProtection
